import { ApolloClient, gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";
import { ID } from "../../utils/id";
import getApolloClient from "../client";

export interface RecordUploadPartInput {
  etag: string;
  partNumber: number;
}

interface Data {
  upload: {
    uploadId: string | null;
    uploadPaths: string[] | null;
  };
}

interface Variables {
  id: ID;
  finished: boolean;
  chunkCount?: number;
  uploadId?: string;
  parts?: RecordUploadPartInput[];
}

const MUTATION = gql`
  mutation multipartUpload(
    $id: ID!
    $finished: Boolean!
    $chunkCount: Int
    $uploadId: String
    $parts: [RecordUploadPartInput!]
  ) {
    upload: multipartUploadRecord(
      id: $id
      finished: $finished
      chunkCount: $chunkCount
      uploadId: $uploadId
      parts: $parts
    ) {
      uploadId
      uploadPaths
    }
  }
`;

export const useRecordMultipartUploadMutation = (
  options: useMutation.Options<Data, Variables> = {},
): useMutation.ResultTuple<Data, Variables> => {
  const oldUpdate = options.update;
  options.update = (cache, result, options) => {
    cache.evict({
      fieldName: "searchRecords",
    });
    cache.gc();

    if (oldUpdate) {
      oldUpdate(cache, result, options);
    }
  };

  return useMutation(MUTATION, options);
};

export const recordMultipartUploadMutate = (
  options: Omit<ApolloClient.MutateOptions<Data, Variables>, "mutation">,
): Promise<ApolloClient.MutateResult<Data>> => {
  const oldUpdate = options.update;
  options.update = (cache, result, options) => {
    cache.evict({
      fieldName: "searchRecords",
    });
    cache.gc();

    if (oldUpdate) {
      oldUpdate(cache, result, options);
    }
  };

  return getApolloClient().mutate<Data, Variables>({
    ...options,
    mutation: MUTATION,
  });
};
